import { render, staticRenderFns } from "./VolumeChart.vue?vue&type=template&id=0f564b6c&"
import script from "./VolumeChart.vue?vue&type=script&lang=ts&"
export * from "./VolumeChart.vue?vue&type=script&lang=ts&"
import style0 from "./VolumeChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports